import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Maison from "@/pages/Maison";
import BrandsIndex from "@/pages/BrandsIndex";
import BrandPage from "@/pages/BrandPage";
import EnergiaProPremium from "@/pages/EnergiaProPremium";
import AcademiePremium from "@/pages/AcademiePremium";
import NandaCosmetiques from "@/pages/NandaCosmetiques";
import IngredientPage from "@/pages/IngredientPage";
import AmenityKit from "@/pages/AmenityKit";
import ConseilImplantation from "@/pages/ConseilImplantation";
import RefrigerationClimatisation from "@/pages/RefrigerationClimatisation";
import EnergiesRenouvelables from "@/pages/EnergiesRenouvelables";
import MatieresPremieresNaturelles from "@/pages/MatieresPremieresNaturelles";
import FiliereCajou from "@/pages/FiliereCajou";
import ProduitsConsommables from "@/pages/ProduitsConsommables";
import EngagementODD from "@/pages/EngagementODD";
import Opportunites from "@/pages/Opportunites";
import SecteurCajou from "@/pages/SecteurCajou";
import SecteurEnergie from "@/pages/SecteurEnergie";
import SecteurTourisme from "@/pages/SecteurTourisme";
import SecteurImmobilier from "@/pages/SecteurImmobilier";
import SecteurAgriculture from "@/pages/SecteurAgriculture";
import SecteurPeche from "@/pages/SecteurPeche";
import SecteurLogistique from "@/pages/SecteurLogistique";
import SecteurElevage from "@/pages/SecteurElevage";
import SecteurArtisanat from "@/pages/SecteurArtisanat";
import SecteurCommerce from "@/pages/SecteurCommerce";
import SecteurEducation from "@/pages/SecteurEducation";
import SecteurNumerique from "@/pages/SecteurNumerique";
import SecteurIndustrie from "@/pages/SecteurIndustrie";
import TresorsIndex from "@/pages/TresorsIndex";
import TresorPage from "@/pages/TresorPage";
import Carnet from "@/pages/Carnet";
import ArticlePage from "@/pages/ArticlePage";
import Actualites from "@/pages/Actualites";
import Impact from "@/pages/Impact";
import Partenaires from "@/pages/Partenaires";
import Rejoindre from "@/pages/Rejoindre";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Sectors from "@/pages/Sectors";
import IdentityKit from "@/pages/IdentityKit";
import Mediatheque from "@/pages/Mediatheque";
import Telecharger from "@/pages/Telecharger";
import Devis from "@/pages/Devis";
import AdminQuoteRequests from "@/pages/AdminQuoteRequests";
import AdminLeads from "@/pages/AdminLeads";
import NotFound from "@/pages/NotFound";

// Legacy redirect helper
function BrandPageLegacy() {
  const slug = window.location.pathname.split("/").pop();
  return <Navigate to={`/marques/${slug}`} replace />;
}

// Redirect legacy /cosmetics/ingredients/:slug and /cosmeticos/ingredientes/:slug to canonical /cosmetiques/ingredients/:slug
function IngredientRedirect() {
  const slug = window.location.pathname.split("/").pop();
  return <Navigate to={`/cosmetiques/ingredients/${slug}`} replace />;
}

export default function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/maison" element={<Maison />} />
              <Route path="/about" element={<Navigate to="/maison" replace />} />
              <Route path="/marques" element={<BrandsIndex />} />
              <Route path="/marques/energia-pro" element={<EnergiaProPremium />} />
              <Route path="/marques/academie" element={<AcademiePremium />} />
              {/* NANDA SÁ Cosmétiques Naturels — Business division (rebrand 2026) */}
              <Route path="/cosmetiques" element={<NandaCosmetiques />} />
              <Route path="/cosmetics" element={<Navigate to="/cosmetiques" replace />} />
              <Route path="/cosmeticos" element={<Navigate to="/cosmetiques" replace />} />
              {/* Ingredient sheets — botanical SEO & storytelling (juillet 2026) */}
              <Route path="/cosmetiques/ingredients/:slug" element={<IngredientPage />} />
              <Route path="/cosmetics/ingredients/:slug" element={<IngredientRedirect />} />
              <Route path="/cosmeticos/ingredientes/:slug" element={<IngredientRedirect />} />
              {/* Amenity Kit configurator — B2B visual configurator (juillet 2026) */}
              <Route path="/cosmetiques/amenity-kit" element={<AmenityKit />} />
              <Route path="/cosmetics/amenity-kit" element={<Navigate to="/cosmetiques/amenity-kit" replace />} />
              <Route path="/cosmeticos/amenity-kit" element={<Navigate to="/cosmetiques/amenity-kit" replace />} />
              {/* Legacy eleone brand redirects → cosmétiques (301) */}
              <Route path="/marques/eleone" element={<Navigate to="/cosmetiques" replace />} />
              <Route path="/brands/eleone" element={<Navigate to="/cosmetiques" replace />} />
              {/* Legacy brand routes hidden in B2B pivot 2026 — redirect to brands index */}
              <Route path="/marques/john-tado" element={<Navigate to="/marques" replace />} />
              <Route path="/marques/kasa" element={<Navigate to="/marques" replace />} />
              <Route path="/conseil-implantation" element={<ConseilImplantation />} />
              <Route path="/conseil" element={<Navigate to="/conseil-implantation" replace />} />
              {/* B2B pillars 2026 */}
              <Route path="/refrigeration-climatisation" element={<RefrigerationClimatisation />} />
              <Route path="/refrigeration" element={<Navigate to="/refrigeration-climatisation" replace />} />
              <Route path="/climatisation" element={<Navigate to="/refrigeration-climatisation" replace />} />
              <Route path="/energies-renouvelables" element={<EnergiesRenouvelables />} />
              <Route path="/energie-solaire" element={<Navigate to="/energies-renouvelables" replace />} />
              <Route path="/matieres-premieres-naturelles" element={<MatieresPremieresNaturelles />} />
              <Route path="/matieres-premieres" element={<Navigate to="/matieres-premieres-naturelles" replace />} />
              <Route path="/filiere-cajou" element={<FiliereCajou />} />
              <Route path="/cajou" element={<Navigate to="/filiere-cajou" replace />} />
              <Route path="/produits-consommables" element={<ProduitsConsommables />} />
              <Route path="/consommables" element={<Navigate to="/produits-consommables" replace />} />
              <Route path="/engagement-odd" element={<EngagementODD />} />
              <Route path="/odd" element={<Navigate to="/engagement-odd" replace />} />
              <Route path="/developpement-durable" element={<Navigate to="/engagement-odd" replace />} />
              <Route path="/opportunites" element={<Opportunites />} />
              <Route path="/opportunites-canchungo" element={<Navigate to="/opportunites" replace />} />
              <Route path="/opportunities" element={<Navigate to="/opportunites" replace />} />
              <Route path="/oportunidades" element={<Navigate to="/opportunites" replace />} />
              <Route path="/marques/:slug" element={<BrandPage />} />
              <Route path="/secteurs" element={<Sectors />} />
              <Route path="/secteurs/cajou" element={<SecteurCajou />} />
              <Route path="/secteurs/energie" element={<SecteurEnergie />} />
              <Route path="/secteurs/tourisme" element={<SecteurTourisme />} />
              <Route path="/secteurs/immobilier" element={<SecteurImmobilier />} />
              <Route path="/secteurs/agriculture" element={<SecteurAgriculture />} />
              <Route path="/secteurs/peche" element={<SecteurPeche />} />
              <Route path="/secteurs/logistique" element={<SecteurLogistique />} />
              <Route path="/secteurs/elevage" element={<SecteurElevage />} />
              <Route path="/secteurs/artisanat" element={<SecteurArtisanat />} />
              <Route path="/secteurs/commerce" element={<SecteurCommerce />} />
              <Route path="/secteurs/education" element={<SecteurEducation />} />
              <Route path="/secteurs/numerique" element={<SecteurNumerique />} />
              <Route path="/secteurs/industrie" element={<SecteurIndustrie />} />
              <Route path="/secteurs/livestock" element={<Navigate to="/secteurs/elevage" replace />} />
              <Route path="/secteurs/pecuaria" element={<Navigate to="/secteurs/elevage" replace />} />
              <Route path="/secteurs/crafts" element={<Navigate to="/secteurs/artisanat" replace />} />
              <Route path="/secteurs/artesanato" element={<Navigate to="/secteurs/artisanat" replace />} />
              <Route path="/secteurs/commerce-trade" element={<Navigate to="/secteurs/commerce" replace />} />
              <Route path="/secteurs/comercio" element={<Navigate to="/secteurs/commerce" replace />} />
              <Route path="/secteurs/education-page" element={<Navigate to="/secteurs/education" replace />} />
              <Route path="/secteurs/educacao" element={<Navigate to="/secteurs/education" replace />} />
              <Route path="/secteurs/digital" element={<Navigate to="/secteurs/numerique" replace />} />
              <Route path="/secteurs/industry" element={<Navigate to="/secteurs/industrie" replace />} />
              <Route path="/secteurs/industria" element={<Navigate to="/secteurs/industrie" replace />} />
              <Route path="/secteurs/cashew" element={<Navigate to="/secteurs/cajou" replace />} />
              <Route path="/secteurs/caju" element={<Navigate to="/secteurs/cajou" replace />} />
              <Route path="/secteurs/energy" element={<Navigate to="/secteurs/energie" replace />} />
              <Route path="/secteurs/energia" element={<Navigate to="/secteurs/energie" replace />} />
              <Route path="/secteurs/tourism" element={<Navigate to="/secteurs/tourisme" replace />} />
              <Route path="/secteurs/turismo" element={<Navigate to="/secteurs/tourisme" replace />} />
              <Route path="/secteurs/real-estate" element={<Navigate to="/secteurs/immobilier" replace />} />
              <Route path="/secteurs/imobiliario" element={<Navigate to="/secteurs/immobilier" replace />} />
              <Route path="/secteurs/agricultura" element={<Navigate to="/secteurs/agriculture" replace />} />
              <Route path="/secteurs/fishing" element={<Navigate to="/secteurs/peche" replace />} />
              <Route path="/secteurs/pesca" element={<Navigate to="/secteurs/peche" replace />} />
              <Route path="/secteurs/logistics" element={<Navigate to="/secteurs/logistique" replace />} />
              <Route path="/secteurs/logistica" element={<Navigate to="/secteurs/logistique" replace />} />
              <Route path="/sectors/cashew" element={<Navigate to="/secteurs/cajou" replace />} />
              <Route path="/sectores/caju" element={<Navigate to="/secteurs/cajou" replace />} />
              <Route path="/sectors" element={<Navigate to="/secteurs" replace />} />
              <Route path="/identite" element={<IdentityKit />} />
              <Route path="/identity" element={<Navigate to="/identite" replace />} />
              <Route path="/brands" element={<Navigate to="/marques" replace />} />
              <Route path="/brands/:slug" element={<BrandPageLegacy />} />
              <Route path="/tresors" element={<TresorsIndex />} />
              <Route path="/tresors/:slug" element={<TresorPage />} />
              <Route path="/carnet" element={<Carnet />} />
              <Route path="/carnet/:slug" element={<ArticlePage />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/impact" element={<Impact />} />
              <Route path="/partenaires" element={<Partenaires />} />
              <Route path="/rejoindre" element={<Rejoindre />} />
              <Route path="/mediatheque" element={<Mediatheque />} />
              <Route path="/telecharger" element={<Telecharger />} />
              <Route path="/download" element={<Telecharger />} />
              <Route path="/media" element={<Navigate to="/mediatheque" replace />} />
              <Route path="/press" element={<Navigate to="/mediatheque" replace />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/devis" element={<Devis />} />
              <Route path="/quote" element={<Navigate to="/devis" replace />} />
              <Route path="/demande" element={<Navigate to="/devis" replace />} />
              <Route path="/legal/:type" element={<Legal />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            {/* Admin — no Layout (no header/footer) */}
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin/devis" element={<AdminQuoteRequests />} />
            <Route path="/admin/quote-requests" element={<AdminQuoteRequests />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </LanguageProvider>
    </div>
  );
}
